import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import InputGalleryItems from "../../components/commons/gallery/InputGalleryItems";

function PromoModal({ show, toggle, type, action, data, register }) {

    const title = type === "add" ? "Tambah Galeri" : "Edit galeri"

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}>
                <ModalHeader className="text-extra-bold pt-5"> {title} <span className="close clickable click-in-right" onClick={toggle}>&times;</span></ModalHeader>
                
                

                <ModalBody>
                    <InputGalleryItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default PromoModal
